module.exports = __webpack_public_path__ + "static/media/fal_fal_sta_pro.e06801c5.png";